import React, { useContext } from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import SearchBar from '../components/SearchBar';
import context from '../context/recipesContext';
import RecipeCardDrink from '../components/RecipeCardDrink';
import FiltersDrinks from '../components/FiltersDrinks';
import './css/Foods.css';

function Drinks() {
  const { searchBarIsVisible, drinks } = useContext(context);

  return (
    <div className="page-foods">
      <div>
        <Header Title="Drinks" />
      </div>
      { searchBarIsVisible && <SearchBar page="drinks" /> }
      <FiltersDrinks />
      <div className="results-section">
        {
          drinks && (
            drinks.map((drink, index) => (
              <RecipeCardDrink key={ index } index={ index } recipe={ drink } />
            ))
          )
        }
      </div>
      <Footer />
    </div>
  );
}

export default Drinks;
